import { render, staticRenderFns } from "./QuestionForm.vue?vue&type=template&id=e94e0e0c&scoped=true"
import script from "./QuestionForm.vue?vue&type=script&lang=js"
export * from "./QuestionForm.vue?vue&type=script&lang=js"
import style0 from "./QuestionForm.vue?vue&type=style&index=0&id=e94e0e0c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e94e0e0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e94e0e0c')) {
      api.createRecord('e94e0e0c', component.options)
    } else {
      api.reload('e94e0e0c', component.options)
    }
    module.hot.accept("./QuestionForm.vue?vue&type=template&id=e94e0e0c&scoped=true", function () {
      api.rerender('e94e0e0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/QuestionForm.vue"
export default component.exports